module.exports = __webpack_public_path__ + "static/envelope-df13d706561a84576c805de078dc69a6.jpg";